/* @flow */
import React from "react";

import Gettext, { withGettext } from "../common/Gettext";
import { Row, Input, SelectColor, SelectWidth } from "../Popup";

export const initialState = {
  periodK: 5,
  periodD: 3,
  algorithm: "EMA",
  slowing: 3,
  strokeWidth: 1,
  colorK: "#39ae00",
  colorD: "#fe003c",
  overbought: 80,
  oversold: 20,
};

export const indicatorTitle = <Gettext>Stochastic Oscillator</Gettext>;

type Props = {
  indicator: Object,
  activeSelect: String,
  handleClick: Function,
  handleChange: Function,
  handleNumberChange: Function
};

const StochasticPopup = (props: Props) => (
  <Row>
    <Input
      label={props.gettext`${"%K"} Period`}
      name="periodK"
      value={props.indicator.periodK}
      onChange={props.handleNumberChange}
      invalid={props.errors && props.errors.periodK}
    />
    <Input
      label={props.gettext`${"%D"} Period`}
      name="periodD"
      value={props.indicator.periodD}
      onChange={props.handleNumberChange}
      invalid={props.errors && props.errors.periodD}
    />
    <Input
      label={props.gettext`Slowing`}
      name="slowing"
      value={props.indicator.slowing}
      onChange={props.handleNumberChange}
      invalid={props.errors && props.errors.slowing}
    />
    <br/>
    <Input
      label={props.gettext`Overbought`}
      name="overbought"
      value={props.indicator.overbought}
      onChange={props.handleNumberChange}
      invalid={props.errors && props.errors.overbought}
    />
    <Input
      label={props.gettext`Oversold`}
      name="oversold"
      value={props.indicator.oversold}
      onChange={props.handleNumberChange}
      invalid={props.errors && props.errors.oversold}
    />
    <br/>
    <SelectColor
      label={props.gettext`${"%K"} Color`}
      name="colorK"
      value={props.indicator.colorK}
      activeSelect={props.activeSelect}
      onClick={props.handleClick}
      onChange={props.handleAsIsChange}
    />
    <SelectColor
      label={props.gettext`${"%D"} Color`}
      name="colorD"
      value={props.indicator.colorD}
      activeSelect={props.activeSelect}
      onClick={props.handleClick}
      onChange={props.handleAsIsChange}
    />
    <SelectWidth
      label={props.gettext`Width of lines`}
      name="strokeWidth"
      value={props.indicator.strokeWidth}
      activeSelect={props.activeSelect}
      onClick={props.handleClick}
      onChange={props.handleAsIsChange}
    />
  </Row>
);

export default withGettext(StochasticPopup);



// WEBPACK FOOTER //
// ./src/components/Toolbar/StochasticPopup.js